// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportStatusEntity from './entities/report-status.json';
import reportStatusMenu from '../pages/report-status/menu.json';
import reportStatusFullForm from '../pages/report-status/forms/full.json';
import reportStatusContextForm from '../pages/report-status/forms/context.json';
import reportStatusMiniForm from '../pages/report-status/forms/mini.json';
import reportStatusLookupForm from '../pages/report-status/forms/lookup.json';
import reportStatusTableView from '../pages/report-status/views/table.json';
import reportStatusDashboardView from '../pages/report-status/views/dashboard.json';

/** Тип запису «Статус звіту» зі сторінками пакета: меню, форми та подання з pages/report-status/. */
export const reportStatusDefinition: IRecordTypeDefinition = {
  ...reportStatusEntity,
  views: assembleViewSet({
      table: reportStatusTableView,
      dashboard: reportStatusDashboardView,
  }),
  form: reportStatusFullForm,
  forms: { full: reportStatusFullForm, context: reportStatusContextForm, mini: reportStatusMiniForm, lookup: reportStatusLookupForm },
  menu: reportStatusMenu,
} as IRecordTypeDefinition;
